export const CANCELLATION_DISCLAIMER_CONTAINER = "CANCELLATION_DISCLAIMER_CONTAINER";
